__turbopack_context__.v({
  "sso_form": "SingleSignOn-module-scss-module__aK1kvG__sso_form",
});
